
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M14 12C14 10.9 13.1 9.99995 12 9.99995C10.9 9.99995 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12ZM12.26 2.99995C7.17 2.85995 3 6.94995 3 12H1.21C0.76 12 0.54 12.54 0.86 12.85L3.65 15.64C3.85 15.84 4.16 15.84 4.36 15.64L7.15 12.85C7.46 12.54 7.24 12 6.79 12H5C5 8.09995 8.18 4.94995 12.1 4.99995C15.82 5.04995 18.95 8.17995 19 11.9C19.05 15.8099 15.9 19 12 19C10.75 19 9.58 18.66 8.56 18.09C8.17 17.87 7.69 17.95 7.38 18.27C6.92 18.73 7.01 19.52 7.58 19.84C8.89 20.57 10.39 21 12 21C17.05 21 21.14 16.83 21 11.74C20.87 7.04995 16.95 3.12995 12.26 2.99995Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-settings-backup-restore`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSettingsBackupRestore

    ```js
    <b-new-b-icon-settings-backup-restore />
    ```
</docs>


